import AppDispatcher from '../dispatcher/AppDispatcher';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';

class RenameAccountsActionCreator {
  setBackPageReference(urlString) {
    const reqPacket = {
      urlString,
    };
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.RENAME_BACKPAGE_REFERENCE,
      data: reqPacket,
    });
  }

  setSelectedAccountID(id) {
    const reqPacket = {
      id,
    };
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.UPDATE_SELECTED_ACCOUNT_ID,
      data: reqPacket,
    });
  }

  updateAccountName(payload) {
    AppDispatcher.handleServerAction({
      actionType: AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME,
      data: payload,
    });
  }

  handleSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME_SUCCESS,
      data: response,
    });
  }

  handleFail(response) {
    AppDispatcher.handleServerAction({
      actionType: AccountsPreferenceConstants.UPDATE_ACCOUNT_NAME_FAIL,
      data: response,
    });
  }
}

export default new RenameAccountsActionCreator();
